import moment from 'moment'

/* @ngInject */
const utilsDate = (
  valueHandler
) => {
  const self = {}

  self.isValidString = (_string) => {
    if (valueHandler.isEmpty(_string) || !valueHandler.isString(_string)) {
      return false
    }

    var regexp = new RegExp('^(?:(?:31(\\/)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)\\d{2})$|^(?:29(\\/)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)\\d{2})$')
    return !!_string.match(regexp)
  }

  self.isValidTimestamp = (_timestamp) => {
    if (valueHandler.isEmpty(_timestamp) || !valueHandler.isNumber(_timestamp)) {
      return false
    }
    if (_timestamp > -8640000000000 && _timestamp < 8640000000000) {
      return true
    }
    return false
  }

  self.isValidDate = (_date) => {
    if (valueHandler.isString(_date)) {
      return false
    }
    const date = moment(_date)
    return date.isValid() && date.isUTC()
  }

  self.stringToDate = (_string) => {
    if (valueHandler.isEmpty(_string)) {
      return null
    }
    return moment(_string, 'DD/MM/YYYY')
  }

  self.dateToString = (_date) => {
    if (valueHandler.isEmpty(_date)) {
      return null
    }
    return moment(_date).format('DD/MM/YYYY')
  }

  self.stringToTimestamp = (_string) => {
    if (valueHandler.isEmpty(_string)) {
      return null
    }
    return moment(_string, 'DD/MM/YYYY').format('X')
  }

  self.timestampToString = (_timestamp) => {
    if (valueHandler.isEmpty(_timestamp)) {
      return null
    }
    return moment.unix(_timestamp).format('DD/MM/YYYY')
  }

  self.timestampToDate = (_timestamp) => {
    if (valueHandler.isEmpty(_timestamp)) {
      return null
    }
    return moment.unix(_timestamp)
  }

  self.dateToTimestamp = (_date) => {
    if (valueHandler.isEmpty(_date)) {
      return null
    }
    return moment(_date).format('X')
  }

  self.getTodayString = () => {
    return moment().format('DD/MM/YYYY')
  }

  self.getToday = () => {
    return moment()
  }

  self.getBeginOfMonthString = () => {
    return moment().startOf('month').format('DD/MM/YYYY')
  }

  self.getBeginOfMonth = () => {
    return moment().startOf('month')
  }
  self.getEndOfMonthString = () => {
    return moment().endOf('month').format('DD/MM/YYYY')
  }

  self.getEndOfMonth = () => {
    return moment().endOf('month')
  }

  self.momentToPHP = (_moment) => {
    if (valueHandler.isEmpty(_moment)) {
      return null
    }
    return moment(_moment).format('YYYY-MM-DD HH:mm:ss')
  }

  self.timestampToPHP = (_timestamp) => {
    if (valueHandler.isEmpty(_timestamp)) {
      return null
    }
    return moment.unix(_timestamp).format('YYYY-MM-DD HH:mm:ss')
  }

  self.stringToPHP = (_string) => {
    if (valueHandler.isEmpty(_string)) {
      return null
    }
    return moment(_string, 'DD/MM/YYYY').format('YYYY-MM-DD HH:mm:ss')
  }

  self.stringToServer = (_string) => {
    return self.isValidString(_string) ? self.stringToPHP(_string) : null
  }

  self.timestampToServer = (_timestamp) => {
    return self.isValidTimestamp(_timestamp) ? self.timestampToPHP(_timestamp) : null
  }

  self.get12MonthsIntervalFromNow = () => {
    const beginMonth = self.getBeginOfMonth()
    const endMonth = self.getEndOfMonth()
    const result = []

    for (let i = 11; i > 0; i--) {
      const begin = beginMonth.clone()
      begin.subtract(i, 'months')
      const end = endMonth.clone()
      end.subtract(i, 'months')

      result.push({ begin, end, })
    }

    result.push({ begin: beginMonth, end: endMonth, })

    return result
  }

  self.get12MonthsNameFromNow = () => {
    const currentMonth = self.getToday().month()
    const months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre',]
    const result = []

    for (let i = 0; i < 12; i++) {
      const current = i + currentMonth + 1
      const index = current >= 12 ? current - 12 : current
      result.push(months[index])
    }

    return result
  }

  return self
}

export default utilsDate



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/utils/utils.date.js